import { CustomAttribute, inject, bindable } from 'aurelia';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.sv.min';

@inject(Element)
export class DatePickerCustomAttribute {
  @bindable value;

  constructor(element) {
    this.element = element;
    this.format = 'yyyy-mm-dd';
  }

  attached() {
    if (CustomAttribute.for(this.element, 'form-field') === undefined) return;
    const view = this.$controller.scope.bindingContext;

    if (this.value) {
      this.format = this.value;
    }

    $(this.element)
      .datepicker({
        orientation: 'bottom',
        autoclose: true,
        language: 'sv',
        weekStart: 1,
        zIndexOffset: 1338,
        todayHighlight: true,
        format: this.format
      })
      .on('changeDate', (c) => {
        const fieldName = CustomAttribute.for(this.element, 'form-field').viewModel.fieldName;
        view.form[fieldName] = this.element.value;
      });
  }
}
